import axios from 'axios'
import { fokaAxios } from 'app/fokaAxios'
import { noop } from 'utils'
import unorm from 'unorm'

let cancelUpload
export const tenthAx = axios.create()
export const getCancelUploadHandler = () => cancelUpload

export const upload = async (
  url,
  file,
  params = {},
  onUploadProgress = noop,
  cancelToken
) => {
  const response = await fokaAxios.get(url, {
    params,
    cancelToken:
      cancelToken ||
      new axios.CancelToken(c => {
        cancelUpload = c
      }),
  })
  const tenthUrl = response.data.url

  // formData.append 순서 중요!
  const formData = new FormData()
  formData.append('type', file.type.startsWith('image') ? 'image' : 'file')
  formData.append('file', file, unorm.nfc(file.name))
  return tenthAx.post(tenthUrl, formData, {
    withCredentials: false,
    onUploadProgress,
    cancelToken:
      cancelToken ||
      new axios.CancelToken(c => {
        cancelUpload = c
      }),
  })
}
